module.exports = __webpack_public_path__ + "img/hero_portrait_wizard_male.26c8f162.png";